// SPDX-License-Identifier: AGPL-3.0-or-later

import * as Modal from '@app/features/app/components/dialogs/Modal';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {SoundboardPopout} from '@app/features/voice/soundboard/components/SoundboardPopout';
import {observer} from 'mobx-react-lite';
import type React from 'react';

interface SoundboardModalProps {
	guildId?: string;
}

export const SoundboardModal: React.FC<SoundboardModalProps> = observer(({guildId}) => {
	return (
		<Modal.Root size="medium" centered>
			<Modal.ScreenReaderLabel text="Soundboard" />
			<SoundboardPopout onClose={() => ModalCommands.pop()} isModal={true} guildId={guildId} />
		</Modal.Root>
	);
});
